const isLandingEntry = require('./isLandingEntry');

const nextEntryState = (previous, location) => {
    const landing = isLandingEntry(location);
    return { landing, hasEntered: !!previous?.hasEntered || !landing };
};

module.exports = nextEntryState;
